import { useTracking } from '@packages/tracking';

export const useLayerTracking = () => {
  const dispatchTracking = useTracking();

  const trackViewLayer = (eventValue: string) => {
    dispatchTracking({
      event: 'ga_event',
      eventAction: 'viewLayer',
      eventCategory: 'noteLayer',
      eventLabel: 'detailview',
      eventValue,
    });
  };

  return {
    trackViewLayer,
  };
};
